export interface ProjectTypeOption {
  label: string;
  value: string;
}

// Single source of truth for "Project Type" everywhere it appears (Create
// Lead's Project Type, Create Project's Type) so both stay in sync instead
// of drifting into two independent option lists.
export const PROJECT_TYPE_OPTIONS: ProjectTypeOption[] = [
  { label: 'Residential', value: 'residential' },
  { label: 'Commercial', value: 'commercial' },
  { label: 'Renovation', value: 'renovation' },
  { label: 'New Construction', value: 'new_construction' },
  { label: 'Maintenance', value: 'maintenance' },
  { label: 'Other', value: 'other' },
];

export function getProjectTypeLabel(value: string | null | undefined): string {
  if (!value) return '-';
  return PROJECT_TYPE_OPTIONS.find((option) => option.value === value)?.label || value;
}
